export const appleRows = [1, 3, 5, 7, 5, 3];

export const generateAppleLayout = () => {
	const totalApples = Math.floor(Math.random() * 6) + 5;
	const totalSlots = appleRows.reduce((sum, count) => sum + count, 0);
	const flatArray = new Array(totalSlots).fill(false);

	let placed = 0;
	while (placed < totalApples) {
		const pos = Math.floor(Math.random() * totalSlots);
		if (!flatArray[pos]) {
			flatArray[pos] = true;
			placed++;
		}
	}

	let index = 0;
	return appleRows.map((count) => {
		const row = flatArray.slice(index, index + count);
		index += count;
		return row;
	});
};

export const applesPositions = [
	{
		id: '1',
		left: 'calc(50% - 343px)',
		bottom: '246px',
		rotate: '15deg',
	},
	{
		id: '2',
		left: 'calc(50% - 245px)',
		bottom: '510px',
		rotate: '30deg',
	},
	{
		id: '3',
		left: 'calc(50% - 164px)',
		bottom: '162px',
		rotate: '0deg',
	},
	{
		id: '4',
		left: 'calc(50% - 185px)',
		bottom: '399px',
		rotate: '-15deg',
	},
	{
		id: '5',
		left: 'calc(50% - 164px)',
		bottom: '714px',
		rotate: '15deg',
	},
	{
		id: '6',
		left: 'calc(50% - 30px)',
		bottom: '640px',
		rotate: '-45deg',
	},
	{
		id: '7',
		left: 'calc(50% + 41px)',
		bottom: '232px',
		rotate: '-30deg',
	},
	{
		id: '8',
		left: 'calc(50% + 110px)',
		bottom: '510px',
		rotate: '-30deg',
	},
	{
		id: '9',
		left: 'calc(50% + 140px)',
		bottom: '670px',
		rotate: '0deg',
	},
	{
		id: '10',
		left: 'calc(50% + 281px)',
		bottom: '580px',
		rotate: '-15deg',
	},
	{
		id: '11',
		left: 'calc(50% + 281px)',
		bottom: '420px',
		rotate: '-30deg',
	},
	{
		id: '12',
		left: 'calc(50% + 251px)',
		bottom: '202px',
		rotate: '0deg',
	},
];
